var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bubble-box"},[_c('div',{staticClass:"text-with-pad"},[_c('span',{staticClass:"removed-message invisible-space"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }